// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ca_a bhb_h bhb_ka bhb_ux bhb_ro bhb_un bhb_rq bhb_rh"};